module.exports = __webpack_public_path__ + "img/picture_viptc03.d35ab6db.png";